import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import WhiteCross from '../img/WhiteCross.svg';
import BlackRightArrow from '../img/BlackRightArrow.svg';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Reverse from '../img/Reverse.png';

const CloudCalculator = ({ submitfunction, setFieldFunction }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const initialValues = {
    workstations: 1,
    servers: 1,
    network_devices: 1,
    cloud_services: 1,
    indexed_data_retention: 1,
    archived_data_retention: 1,
    average_size_per_kb: 0,
    workstations_events_per_second_per_device: 1,
    servers_events_per_second_per_device: 2.5,
    network_devices_events_per_second_per_device: 5,
    cloud_services_events_per_second_per_device: 10,
    percentage_added_for_error_estimation: 0,
  };

  const handleSubmit = () => {
    console.log('algo');
  };

  const calculateActiveAgents = (value1, value2) => {
    if (value1 + value2 <= 100) {
      return 'Up to 100';
    } else if (value1 + value2 <= 250) {
      return 'Up to 250';
    } else if (value1 + value2 <= 500) {
      return 'Up to 500';
    } else if (value1 + value2 <= 1000) {
      return 'Up to 1000';
    } else if (value1 + value2 <= 2000) {
      return 'Up to 2000';
    } else if (value1 + value2 <= 4000) {
      return 'Up to 4000';
    } else if (value1 + value2 <= 6000) {
      return 'Up to 6000';
    } else if (value1 + value2 <= 8000) {
      return 'Up to 8000';
    } else if (value1 + value2 <= 10000) {
      return 'Up to 10000';
    } else {
      return 'More than 10000';
    }
  };

  const calculateIndexedDataRetention = (value) => {
    if (value <= 30) {
      return '1 month';
    } else if (value <= 90) {
      return '3 months';
    } else if (value <= 180) {
      return '6 months';
    } else {
      return 'More than 6 months';
    }
  };

  const calculateArchiveDataRetention = (indexedDataRetebtuibValue, value) => {
    if (value <= 90) {
      if (indexedDataRetebtuibValue <= 90) {
        return '3 months';
      } else if (indexedDataRetebtuibValue <= 180) {
        return '6 months';
      } else if (indexedDataRetebtuibValue <= 365) {
        return '1 year';
      } else {
        return 'More than 1 year';
      }
    } else if (value <= 180) {
      if (indexedDataRetebtuibValue <= 180) {
        return '6 months';
      } else if (indexedDataRetebtuibValue <= 365) {
        return '1 year';
      } else {
        return 'More than 1 year';
      }
    } else if (value <= 365) {
      if (indexedDataRetebtuibValue <= 365) {
        return '1 year';
      } else {
        return 'More than 1 year';
      }
    } else {
      return 'More than 1 year';
    }
  };

  const calculateAproxAverageEPS = (
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    value7,
    value8
  ) => {
    return (
      value1 * value2 + value3 * value4 + value5 * value6 + value7 * value8
    );
  };

  const calculateIndexedDataCapacity = (
    value1,
    value2,
    value3,
    value4,
    value5
  ) => {
    const var1 = ((1 + 0.3 / 100) * (86400 * (value2 * (0.1 * 1)))) / 1000000;
    const var2 = ((1 + 0.3 / 100) * (86400 * (value3 * (0.25 * 1)))) / 1000000;
    const var3 = ((1 + 0.3 / 100) * (86400 * (value4 * (0.5 * 1)))) / 1000000;
    const var4 = ((1 + 0.3 / 100) * (86400 * (value5 * (1 * 1)))) / 1000000;
    const res1 = value1 * var1;
    const res2 = value1 * var2;
    const res3 = value1 * var3;
    const res4 = value1 * var4;

    const result = res1 + res2 + res3 + res4;
    return result;
  };

  // const calculateArchivedDataGB = (value1, value2, value3, value4, value5) => {
  //   const var1 =
  //     ((1 + 0.3 / 100) * (86400 * (value2 * (0.1 * 1)))) / 1000000 / 12;
  //   const var2 =
  //     ((1 + 0.3 / 100) * (86400 * (value3 * (0.25 * 1)))) / 1000000 / 12;
  //   const var3 =
  //     ((1 + 0.3 / 100) * (86400 * (value4 * (0.5 * 1)))) / 1000000 / 12;
  //   const var4 =
  //     ((1 + 0.3 / 100) * (86400 * (value5 * (1 * 1)))) / 1000000 / 12;
  //   const result1 = value1 * var1;
  //   const result2 = value1 * var2;
  //   const result3 = value1 * var3;
  //   const result4 = value1 * var4;
  //   if (result1 + result2 + result3 + result4 > 5) {
  //     return result1 + result2 + result3 + result4;
  //   } else {
  //     return 5;
  //   }
  // };

  const handleResetValues = async (setFieldValue) => {
    await setFieldValue('workstations', 1);
    await setFieldValue('network_devices', 1);
    await setFieldValue('servers', 1);
    await setFieldValue('cloud_services', 1);
    await setFieldValue('indexed_data_retention', 1);
    await setFieldValue('archived_data_retention', 1);
  };

  return (
    <>
      <button
        type='button'
        onClick={openModal}
        className='btn bg-yellow-gradient text-sm font-medium text-black rounded-xl flex w-[200px] 2xl:w-[240px] py-2 justify-center'
      >
        Cloud settings calculator
        <img
          className='ml-1 relative top-[1px] w-[5px]'
          src={BlackRightArrow}
        ></img>
      </button>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as='div'
          className='relative z-10 w-[900px]'
          onClose={handleCloseModal}
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-5xl font-manrope transform overflow-hidden rounded-2xl bg-white dark:bg-blackbg text-left align-middle shadow-xl transition-all'>
                  <Formik
                    initialValues={initialValues}
                    onSubmit={(values) => {
                      submitfunction(
                        {
                          active_agents: calculateActiveAgents(
                            values.workstations,
                            values.servers
                          ),
                          indexed_data_retention_value:
                            calculateIndexedDataRetention(
                              values.indexed_data_retention
                            ),
                          archived_data_retention_value:
                            calculateArchiveDataRetention(
                              values.indexed_data_retention,
                              values.archived_data_retention
                            ),
                          average_peak_eps_value: calculateAproxAverageEPS(
                            values.workstations,
                            values.workstations_events_per_second_per_device,
                            values.servers,
                            values.servers_events_per_second_per_device,
                            values.network_devices,
                            values.network_devices_events_per_second_per_device,
                            values.cloud_services,
                            values.cloud_services_events_per_second_per_device
                          ),
                          indexed_data_capacity: calculateIndexedDataCapacity(
                            values.indexed_data_retention,
                            values.workstations,
                            values.servers,
                            values.network_devices,
                            values.cloud_services
                          ).toFixed(2),
                          ...values,
                        },
                        setFieldFunction
                      );
                    }}
                  >
                    {({ values, setFieldValue }) => (
                      <Form>
                        <div className='bg-mainblue rounded-tl-xl rounded-tr-xl p-3 flex justify-between pl-[20px]'>
                          <Dialog.Title
                            as='h3'
                            className='text-2xl py-1 font-medium leading-6 text-white'
                          >
                            Cloud settings calculator
                          </Dialog.Title>
                          <img
                            src={WhiteCross}
                            onClick={closeModal}
                            className='text-black hover:cursor-pointer mr-1'
                          ></img>
                        </div>
                        <div className='mt-2 p-6 px-10 flex flex-col md:flex-row justify-between items-center'>
                          <div className='font-semibold self-start relative bottom-[2px] dark:text-white'>
                            Sources
                          </div>
                          <div class='border-b border-gray-300 w-auto flex-1 relative mx-2'></div>

                          <div className='flex justify-center md:justify-center py-1 w-full md:w-[155px] items-center hover:bg-blue-600 hover:cursor-pointer bg-blue-500 text-white rounded-lg'>
                            <button
                              onClick={() => handleResetValues(setFieldValue)}
                              className='focus:outline-none'
                            >
                              Reset values
                            </button>
                            <img className='w-4 h-4 ml-2' src={Reverse}></img>
                          </div>
                        </div>
                        <div className='flex flex-col md:flex-row justify-between px-10 gap-4 md:gap-20'>
                          <div className='flex flex-col md:flex-row relative justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Workstations:
                            </div>
                            <Field
                              className='border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md w-full md:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='1'
                              type='number'
                              name='workstations'
                              min='1'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                          <div className='flex flex-col md:flex-row relative justify-self-end justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Network devices:
                            </div>
                            <Field
                              className='border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md w-full md:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='0'
                              type='number'
                              name='network_devices'
                              min='0'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                        </div>
                        <div className='flex flex-col md:flex-row justify-between px-10 mt-5 gap-4 md:gap-20'>
                          <div className='flex flex-col md:flex-row relative justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Servers:
                            </div>
                            <Field
                              className=' border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md w-full md:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='1'
                              type='number'
                              name='servers'
                              min='1'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                          <div className='flex flex-col md:flex-row relative justify-self-end justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Cloud services (accounts):
                            </div>
                            <Field
                              className=' border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md w-full md:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='0'
                              type='number'
                              name='cloud_services'
                              min='0'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                        </div>
                        <div className='mt-2 p-6 px-10 flex justify-between'>
                          <div className='font-semibold dark:text-white'>
                            Retention periods
                          </div>
                          <div class='hidden md:block border-b border-gray-200 w-auto flex-1 relative bottom-2 ml-2'></div>
                        </div>
                        <div className='flex flex-col md:flex-row justify-between px-10 mb-10 gap-4 md:gap-20'>
                          <div className='flex flex-col md:flex-row relative justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Indexed data retention(days):
                            </div>
                            <Field
                              className='  border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md md:w-[115px] 2xl:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='0'
                              type='number'
                              name='indexed_data_retention'
                              min='0'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                          <div className='flex flex-col md:flex-row relative justify-self-end justify-between md:w-1/2 md:items-center'>
                            <div className='text-sm dark:text-white'>
                              Archived data retention (days):
                            </div>
                            <Field
                              className=' border dark:bg-blackbg dark:text-white focus:border-[#3D82F1] border-[#B7C6D7] text-sm rounded-md md:w-[115px] 2xl:w-[155px] h-[34px] px-3 py-1 text-black placeholder-[#B7C6D7]'
                              placeholder='0'
                              type='number'
                              name='archived_data_retention'
                              min='0'
                            ></Field>
                            <p className='text-red-500 absolute top-0 right-2'>
                              *
                            </p>
                          </div>
                        </div>
                        <div className='px-6'>
                          <div className='bg-black rounded-t-xl relative'>
                            <div className='absolute hidden  text-2xl font-semibold left-[calc(50%-35px)] bottom-3 w-[70px] h-[70px] justify-center items-center md:flex rounded-full text-white bg-blue-500 border-white dark:border-[#2b2d34] border-8'>
                              =
                            </div>
                            <div className='text-white ml-4 font-semibold py-3'>
                              Storage estimation
                            </div>
                          </div>
                          <div className=' border-gray-100 border-b border-r border-l rounded-b-3xl'>
                            <div className='flex flex-col md:flex-row justify-between mx-4 pt-5 gap-4 md:gap-20'>
                              <div className='flex flex-col md:flex-row text-sm md:w-1/2 md:items-center justify-between'>
                                <div className='dark:text-white'>
                                  Active Agents
                                </div>
                                <div className='items-center flex border focus:border-[#3D82F1] border-[#B7C6D7] rounded-md md:w-[155px] h-[34px] px-3 py-1 text-gray-500 dark:text-gray-300 placeholder-[#B7C6D7] overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {calculateActiveAgents(
                                    values.workstations,
                                    values.servers
                                  )}
                                </div>
                              </div>
                              <div className='flex flex-col md:flex-row text-sm md:w-1/2 md:items-center justify-between'>
                                <div className='dark:text-white'>
                                  Approximate average EPS
                                </div>
                                <div className='items-center flex border focus:border-[#3D82F1] border-[#B7C6D7] text-gray-500 dark:text-gray-300 rounded-md md:w-[155px] h-[34px] px-3 py-1 placeholder-[#B7C6D7] overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {calculateAproxAverageEPS(
                                    values.workstations,
                                    values.workstations_events_per_second_per_device,
                                    values.servers,
                                    values.servers_events_per_second_per_device,
                                    values.network_devices,
                                    values.network_devices_events_per_second_per_device,
                                    values.cloud_services,
                                    values.cloud_services_events_per_second_per_device
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='flex flex-col md:flex-row justify-between mx-4 mt-5 gap-4 md:gap-20'>
                              <div className='flex flex-col md:flex-row text-sm md:w-1/2 md:items-center justify-between'>
                                <div className='dark:text-white'>
                                  Indexed data retention
                                </div>
                                <div className='items-center flex border focus:border-[#3D82F1] border-[#B7C6D7] rounded-md md:w-[155px] h-[34px] px-3 py-1 text-gray-500 dark:text-gray-300 placeholder-[#B7C6D7] overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {calculateIndexedDataRetention(
                                    values.indexed_data_retention
                                  )}
                                </div>
                              </div>
                              <div className='flex flex-col md:flex-row text-sm md:w-1/2 md:items-center justify-between'>
                                <div className='dark:text-white'>
                                  Indexed data capacity (GB)
                                </div>
                                <div className='items-center flex border focus:border-[#3D82F1] border-[#B7C6D7] rounded-md md:w-[155px] h-[34px] px-3 py-1 text-gray-500 dark:text-gray-300 placeholder-[#B7C6D7] overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {calculateIndexedDataCapacity(
                                    values.indexed_data_retention,
                                    values.workstations,
                                    values.servers,
                                    values.network_devices,
                                    values.cloud_services
                                  ).toFixed(2)}
                                </div>
                              </div>
                            </div>
                            <div className='flex flex-col md:flex-row justify-between mx-4 mt-5 gap-4 md:gap-20'>
                              <div className='flex flex-col md:flex-row text-sm md:w-1/2 md:items-center justify-between'>
                                <div className='dark:text-white'>
                                  Archive data retention
                                </div>
                                <div className='items-center flex border focus:border-[#3D82F1] border-[#B7C6D7] rounded-md md:w-[155px] h-[34px] px-3 py-1 text-gray-500 dark:text-gray-300 placeholder-[#B7C6D7] overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {calculateArchiveDataRetention(
                                    values.indexed_data_retention,
                                    values.archived_data_retention
                                  )}
                                </div>
                              </div>
                              <div className='flex text-sm w-1/2 items-center justify-between'>
                                {/* <div>Archived data (GB)</div> 
                                <div className=' rounded-md w-[155px] h-[34px] px-3 py-1 overflow-hidden whitespace-nowrap text-ellipsis'>
                                  {/* {calculateArchivedDataGB(
                                    values.archived_data_retention,
                                    values.workstations,
                                    values.servers,
                                    values.network_devices,
                                    values.cloud_services
                                  ).toFixed(2)} 
                                </div> */}
                              </div>
                            </div>

                            <div className='px-4 mt-10 hidden md:block'>
                              <div className='bg-[#f1f1f1] dark:bg-blackbgdark dark:text-white text-center md:text-start grid grid-cols-1 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className=' col-span-1 md:col-span-2'>
                                  Parameters used for storage estimation
                                </div>
                                <div className='flex justify-center'>
                                  Workstations
                                </div>
                                <div className='flex justify-center'>
                                  Servers
                                </div>
                                <div className='flex justify-center'>
                                  Network devices
                                </div>
                                <div className='flex justify-center'>
                                  Cloud services
                                </div>
                              </div>
                              <div className='text-center dark:text-white md:text-start grid grid-cols-1 gap-2 md:gap-0 md:grid-cols-6 px-4 py-4 text-sm'>
                                <div className='col-span-1 md:col-span-2 leading-10'>
                                  Number of devices
                                </div>
                                <div className='flex w-full justify-center'>
                                  {values.workstations || 1}
                                </div>
                                <div>
                                  <div className='flex w-full justify-center'>
                                    {values.servers || 1}
                                  </div>
                                </div>
                                <div className='flex justify-center'>
                                  {' '}
                                  {values.network_devices || 1}
                                </div>
                                <div className='flex justify-center'>
                                  {values.cloud_services || 1}
                                </div>
                                <div className='md:col-span-2 leading-10'>
                                  Average size per event (KB)
                                </div>
                                <div className='flex justify-center'>1</div>
                                <div className='flex justify-center'>1</div>
                                <div className='flex justify-center'>1</div>
                                <div className='flex justify-center'>1</div>
                                <div className='md:col-span-2 leading-10'>
                                  Events per second per device
                                </div>
                                <div className=''>
                                  <Field
                                    className='w-full flex text-center bg-white dark:bg-blackbg'
                                    placeholder='2'
                                    type='text'
                                    disabled='true'
                                    name='workstations_events_per_second_per_device'
                                    min='0'
                                  ></Field>
                                </div>
                                <div className='flex justify-center'>
                                  {values.servers_events_per_second_per_device}
                                </div>
                                <div className='flex justify-center'>
                                  {
                                    values.network_devices_events_per_second_per_device
                                  }
                                </div>
                                <div className='flex justify-center'>
                                  {
                                    values.cloud_services_events_per_second_per_device
                                  }
                                </div>
                                <div className='md:col-span-2 leading-10'>
                                  Alerts per second per device
                                </div>
                                <div className='flex justify-center'>
                                  {values.workstations_events_per_second_per_device /
                                    10}
                                </div>
                                <div className='flex justify-center'>0.25</div>
                                <div className='flex justify-center'>0.5</div>
                                <div className='flex justify-center'>1</div>
                                <div className='md:col-span-2 leading-10'>
                                  Percentage added for error estimation
                                </div>
                                <div className='flex justify-center'>0.3</div>
                                <div className='flex justify-center'>0.3</div>
                                <div className='flex justify-center'>0.3</div>
                                <div className='flex justify-center'>0.3</div>
                              </div>
                            </div>
                            <div className='mt-10 md:hidden'>
                              <div className='bg-[#f1f1f1] items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'>
                                  Parameters used for storage estimation
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  Workstations
                                </div>
                              </div>
                              <div className='items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'>
                                  Number of devices
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.workstations || 1}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Average size per event (KB)
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  1
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Events per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  <Field
                                    className='w-full flex text-center bg-white'
                                    placeholder='1'
                                    type='text'
                                    disabled='true'
                                    name='workstations_events_per_second_per_device'
                                    min='0'
                                  ></Field>
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Alerts per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.workstations_events_per_second_per_device /
                                    10}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Percentage added for error estimation
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.3
                                </div>
                              </div>
                              <div className='bg-[#f1f1f1] items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'></div>
                                <div className='col-span-2 text-xs text-center'>
                                  Servers
                                </div>
                              </div>
                              <div className='items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'>
                                  Number of devices
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.servers || 1}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Average size per event (KB)
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  1
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Events per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.servers_events_per_second_per_device}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Alerts per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.25
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Percentage added for error estimation
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.3
                                </div>
                              </div>
                              <div className='bg-[#f1f1f1] items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'></div>
                                <div className='col-span-2 text-xs text-center'>
                                  Network devices
                                </div>
                              </div>
                              <div className='items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'>
                                  Number of devices
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.network_devices || 1}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Average size per event (KB)
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  1
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Events per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {
                                    values.network_devices_events_per_second_per_device
                                  }
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Alerts per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.5
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Percentage added for error estimation
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.3
                                </div>
                              </div>
                              <div className='bg-[#f1f1f1] items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'></div>
                                <div className='col-span-2 text-xs text-center'>
                                  Cloud services
                                </div>
                              </div>
                              <div className='items-center md:text-start grid grid-cols-6 gap-2 md:gap-0 md:grid-cols-6 rounded-t-xl font-semibold px-4 py-4 text-sm'>
                                <div className='col-span-4 text-xs'>
                                  Number of devices
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {values.cloud_services || 1}
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Average size per event (KB)
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  1
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Events per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  {
                                    values.cloud_services_events_per_second_per_device
                                  }
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Alerts per second per device
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  1
                                </div>
                                <div className='col-span-4 text-xs'>
                                  Percentage added for error estimation
                                </div>
                                <div className='col-span-2 text-xs text-center'>
                                  0.3
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='mt-4 flex flex-col md:flex-row justify-end p-6'>
                          <div className='flex justify-center mb-4 md:mb-auto md:justify-around h-[36px] py-1 md:px-16 items-center hover:bg-blue-600 hover:cursor-pointer bg-blue-500 text-white rounded-lg'>
                            <button
                              type='button'
                              onClick={() => handleResetValues(setFieldValue)}
                            >
                              Reset values
                            </button>
                            <img className='w-4 h-4 ml-2' src={Reverse}></img>
                          </div>
                          <button
                            onClick={closeModal}
                            type='submit'
                            className='inline-flex md:ml-5 justify-center rounded-md btn bg-yellow-gradient h-[36px] md:h-auto px-16 py-2 text-sm font-medium'
                          >
                            Save and continue
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CloudCalculator;
